import React from 'react';

interface Color {
    color: string;
}

export const Plus = ({ color = '#1094F7' }: Color) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.2669 7.36662H8.63353V3.73328C8.63353 3.38366 8.34983 3.09995 8.0002 3.09995C7.65057 3.09995 7.36686 3.38366 7.36686 3.73328V7.36662H3.73353C3.3839 7.36662 3.1002 7.65032 3.1002 7.99995C3.1002 8.34958 3.3839 8.63329 3.73353 8.63329H7.36686V12.2666C7.36686 12.6162 7.65057 12.9 8.0002 12.9C8.34983 12.9 8.63353 12.6162 8.63353 12.2666V8.63329H12.2669C12.6165 8.63329 12.9002 8.34958 12.9002 7.99995C12.9002 7.65032 12.6165 7.36662 12.2669 7.36662Z"
                fill={color}
                stroke={color}
                strokeWidth="0.2"
            />
        </svg>
    );
};
